import { c as _c } from "react/compiler-runtime";
import { resolveInventoryAvailability } from "./stock";
export const ProductStockLabel = t0 => {
  const $ = _c(8);
  const {
    product
  } = t0;
  const t1 = product?.trackInventory;
  const t2 = product?.stock;
  const t3 = product?.inventoryLevels;
  const t4 = product?.variants;
  let t5;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = resolveInventoryAvailability({
      trackInventory: t1,
      stock: t2,
      inventoryLevels: t3,
      variants: t4
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const availability = t5;
  const t6 = `text-xs font-lealti-light ${availability.inStock ? "text-[#6D7175]" : "text-[#BE123C]"}`;
  let t7;
  if ($[5] !== availability.label || $[6] !== t6) {
    t7 = <p className={t6}>{availability.label}</p>;
    $[5] = availability.label;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};